// extracted by mini-css-extract-plugin
export default {"genericCard":"Bp-z","inline":"Cp-z","mastercard":"Dp-z","discover":"Ep-z","visa":"Fp-z","amex":"Gp-z","active":"Hp-z"};